/* * 本页面为企业认证申请页面 * 通过pageType字段来区分：1新增，2修改 * */
<template>
  <div ref="pageView" class="page-view container-view">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title>
        {{ pageTitle }}
        <template slot="breadcrumb">
          <e6-breadcrumb :breadcrumbs="breadcrumbs"></e6-breadcrumb>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- content -->
    <section
      class="content-section"
      :style="{ height: resizeViewHeight + 'px' }"
    >
      <div class="form-wrapper">
        <e6-form-extend
          class="e6-from--column-2"
          ref="formExtend"
          :formExtend="formExtend"
          :inline="true"
          label-width="200px"
          :submitLoadingState="loadingState"
        >
          <template slot-scope="slotForms">
            <el-form-item label="企业名称" prop="forms.comparyName">
              <el-input
                disabled
                v-model="slotForms.forms.comparyName"
                placeholder="企业名称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="社会统一信用代码" prop="forms.creditUnicode">
              <el-input
                disabled
                v-model="slotForms.forms.creditUnicode"
                placeholder="社会统一信用代码"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="forms.serviceObjects"
              label="服务对象"
              :rules="[
                { required: true, message: '请选择服务对象', trigger: 'blur' }
              ]"
            >
              <el-select
                disabled
                collapse-tags
                v-model="slotForms.forms.serviceObjects"
                filterable
                multiple
                value-key="dicId"
                placeholder="服务对象"
              >
                <el-option
                  v-for="item in serviceObjectList"
                  :key="item.dicId"
                  :label="item.dicName"
                  :value="item.dicId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              prop="forms.operateProducts"
              label="经营产品类型"
              :rules="[
                {
                  required: true,
                  message: '请选择经营产品类型',
                  trigger: 'blur'
                }
              ]"
            >
              <el-select
                disabled
                v-model="slotForms.forms.operateProducts"
                collapse-tags
                filterable
                multiple
                value-key="dicId"
                placeholder="经营产品类型"
              >
                <el-option
                  v-for="item in operateProductList"
                  :key="item.dicId"
                  :label="item.dicName"
                  :value="item.dicId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否会员企业企业" prop="forms.isCpCorp">
              <el-radio
                disabled
                v-model="slotForms.forms.isVipMember"
                :label="0"
                >否</el-radio
              >
              <el-radio
                disabled
                v-model="slotForms.forms.isVipMember"
                :label="1"
                >是</el-radio
              >
              <br />
              <dict-select
                isDisabled
                v-if="slotForms.forms.isVipMember == '1'"
                v-model="slotForms.forms.vipCategory"
                placeholder="请选择会员类型"
                :pkey="'vip_category'"
              ></dict-select>
            </el-form-item>
            <br/>
            <el-form-item prop="forms.businessLicPhoto" label="营业执照:">
              <el-upload
                class="el-upload-list__item-thumbnail"
                :class="{ hide: hideBusinessUpload }"
                action="/app/file/upload"
                :on-preview="handleBusinessPreview"
                :on-remove="handleBusinessRemove"
                :on-success="handleBusinessAvatarSuccess"
                :on-change="handleBusinessChange"
                :beforeUpload="beforeAvatarUpload"
                :file-list="businessLicPhotoFileList"
                list-type="picture-card"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item prop="forms.registeIdCardImg" label="注册人身份证">
              <el-upload
                class="el-upload-list__item-thumbnail"
                :class="{ hide: hideIdCardUpload }"
                action="/app/file/upload"
                :on-preview="handleIdCardPreview"
                :on-remove="handleIdCardRemove"
                :on-success="handleIdCardAvatarSuccess"
                :on-change="handleIdCardChange"
                :beforeUpload="beforeAvatarUpload"
                :file-list="fileIdCardList"
                list-type="picture-card"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item prop="forms.addImgsList" label="补充文件">
              <el-upload
                class="el-upload-list__item-thumbnail"
                :class="{ hide: hideAddUpload }"
                action="/app/file/upload"
                :on-preview="handleAddPreview"
                :on-remove="handleAddRemove"
                :on-success="handleAddAvatarSuccess"
                :on-change="handleAddChange"
                :beforeUpload="beforeAvatarUpload"
                :file-list="addFileList"
                list-type="picture-card"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item class="remarkWidth" prop="forms.auditReportImgsList" label="审计报告">
              <el-upload
                class="el-upload-list__item-thumbnail"
                :class="{ hide: hideReportUpload }"
                action="/app/file/upload"
                :on-preview="handleReportPreview"
                :on-remove="handleReportRemove"
                :on-success="handleReportAvatarSuccess"
                :on-change="handleReportChange"
                :beforeUpload="beforeAvatarUpload"
                :file-list="reportFileList"
                list-type="picture-card"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
            <el-dialog :visible.sync="dialogVisible" :modal-append-to-body="false">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            <br/>
            <el-form-item class="remarkWidth" prop="forms.examineMsg" label="审核意见"
            :rules="[{ validator: CheckRemarkLength, trigger: 'blur' }]"
            >
              <el-input
                type="textarea"
                :rows="3"
                v-model.number="slotForms.forms.examineMsg"
                placeholder="审核意见"
              ></el-input>
            </el-form-item>
          </template>
        </e6-form-extend>
        <section class="operate-section">
          <el-button :loading="loadingState" type="primary" @click="handleSubmitForm"
            >审核通过</el-button
          >
          <el-button :loading="loadingState" @click="handleResetForm">审核不通过</el-button>
        </section>
      </div>
    </section>

    <!-- content end -->
  </div>
</template>
<script>
import {
  SaveCertificationReview,
  FindBaseComparyInfoById
} from '@/api/base/customsDeclaration'
import {
  CheckRemarkLength
} from '@/utils/validation'
import resizeListener from '_private/mixins/resizeListener'
export default {
  mixins: [resizeListener],
  data() {
    return {
      breadcrumbs: [
        {
          path: '/home',
          isRedirect: true,
          meta: {
            title: '首页'
          }
        },
        {
          path: '/baseCertificationReviewList',
          isRedirect: true,
          meta: {
            title: '企业认证审核'
          }
        }
      ],
      formExtend: {
        forms: {
          comparyName: '',
          creditUnicode: '',
          businessLicPhoto: '',
          auditReportImgsList: [],
          addImgsList: [],
          registeIdCardImg: '',
          serviceObjects: '',
          isVipMember: '',
          operateProducts: '',
          vipCategory: '',
          examineMsg: ''
        },
        extends: []
      },
      hideBusinessUpload: false,
      hideIdCardUpload: false,
      hideAddUpload: false,
      hideReportUpload: false,
      operateProductList: '',
      serviceObjectList: '',
      dialogImageUrl: '',
      dialogVisible: false,
      businessLicPhotoFileList: [],
      reportFileList: [],
      addFileList: [],
      fileIdCardList: [],
      CheckRemarkLength:CheckRemarkLength,
      editState: false,
      loadingState: false
    }
  },
  computed: {
    pageType() {
      return this.$route.query.pageType ? this.$route.query.pageType : '1'
    },
    pageTitle() {
      const pageTitle = this.pageType === '1' ? '' : '企业认证审核'
      return pageTitle
    },
    id() {
      return this.$route.query.id
    }
  },
  created() {
    this.initServiceObjectSelect()
    this.initOperateProductSelect()
    let breadcrumb = {
      path: '/systemSettingDataDictionaryMaintenanceEdit',
      isRedirect: false,
      meta: {
        title: this.pageTitle
      }
    }
    this.breadcrumbs.push(breadcrumb)
    if (this.pageType !== '1') {
      this.FindBaseComparyInfoById({ comparyId: this.id })
      this.editState = true
    }
  },
  methods: {
    /**
     *  初始化企业服务对象字典列表
     */
    initServiceObjectSelect() {
      this.$axios
        .post(
          '/base/dictionary/getDictByDicTypeKey',
          this.$qs.stringify({
            dicTypeKey: 'corp_service_object'
          })
        )
        .then(e => {
          if (e.data.code === 1) {
            this.serviceObjectList = e.data.result
          } else {
            this.errorMessage(e.data.message, e.data.code)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     *  初始化企业服务对象字典列表
     */
    initOperateProductSelect() {
      this.$axios
        .post(
          '/base/dictionary/getDictByDicTypeKey',
          this.$qs.stringify({
            dicTypeKey: 'manage_product'
          })
        )
        .then(e => {
          if (e.data.code === 1) {
            this.operateProductList = e.data.result
          } else {
            this.errorMessage(e.data.message, e.data.code)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
     beforeAvatarUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'jpg'
      const extension2 = testmsg === 'png'
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2) {
        this.$message({
          message: '上传文件只能是 jpg、png格式!',
          type: 'warning'
        })
      }
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 10MB!',
          type: 'warning'
        })
      }
      return extension || (extension2 && isLt2M)
    },
    //营业执照上传
    handleBusinessRemove() {
      // DeleteFile({ fileName: file.url })
      // this.formExtend.forms.businessLicPhoto = ''
      // this.hideBusinessUpload = fileList.length >= 1
    },
    handleBusinessPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleBusinessAvatarSuccess(res) {
      this.formExtend.forms.businessLicPhoto = res.result.filename
    },
    handleBusinessChange(file, fileList) {
      this.hideBusinessUpload = fileList.length >= 1
    },
    //注册人身份证照片
    handleIdCardRemove() {
      // DeleteFile({ fileName: file.url })
      // this.formExtend.forms.registeIdCardImg = ''
      // this.hideIdCardUpload = fileList.length >= 1
    },
    handleIdCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleIdCardAvatarSuccess(res) {
      this.formExtend.forms.registeIdCardImg = res.result.filename
    },
    handleIdCardChange(file, fileList) {
      this.hideIdCardUpload = fileList.length >= 1
    },
    //补充文件上传
    handleAddRemove() {
      // DeleteFile({ fileName: file.url })
      // var index = this.formExtend.forms.addImgsList.findIndex(item => {
      //   if (item == file.url) {
      //     return true
      //   }
      // })
      // this.formExtend.forms.addImgsList.splice(index, 1)
      // this.hideAddUpload = fileList.length >= 2
    },
    handleAddPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleAddAvatarSuccess(res) {
      this.formExtend.forms.addImgsList.push(res.result.filename)
    },
    handleAddChange(file, fileList) {
      this.hideAddUpload = fileList.length >= 2
    },
    //审计报告
    handleReportRemove() {
      // DeleteFile({ fileName: file.url })
      // var index = this.formExtend.forms.auditReportImgsList.findIndex(item => {
      //   if (item == file.url) {
      //     return true
      //   }
      // })
      // this.formExtend.forms.auditReportImgsList.splice(index, 1)
      // this.hideReportUpload = fileList.length >= 4
    },
    handleReportPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleReportAvatarSuccess(res) {
      this.formExtend.forms.auditReportImgsList.push(res.result.filename)
    },
    handleReportChange(file, fileList) {
      this.hideReportUpload = fileList.length >= 4
    },
    // 获取企业审核数据
    FindBaseComparyInfoById(response) {
      FindBaseComparyInfoById(response)
        .then(response => {
          this.formExtend.forms = Object.assign({}, response.result)
          //营业执照
          if (response.result.businessLicPhoto) {
            this.businessLicPhotoFileList = [
              { url: response.result.businessLicPhoto }
            ]
            this.hideBusinessUpload = this.businessLicPhotoFileList.length >= 1
          }
          //注册人身份证
          if (response.result.registeIdCardImg) {
            this.fileIdCardList = [{ url: response.result.registeIdCardImg }]
            this.hideIdCardUpload = this.businessLicPhotoFileList.length >= 1
          }
          //补充文件
          if (response.result.addImgs) {
            var addFiles = response.result.addImgs.split(',')
            addFiles.forEach(item => {
              this.addFileList.push({ url: item })
              this.formExtend.forms.addImgsList.push(item)
            })
            this.hideAddUpload = this.addFileList.length >= 2
          }
          //审计报告
          if (response.result.auditReportImgs) {
            var reportFiles = response.result.auditReportImgs.split(',')
            reportFiles.forEach(item => {
              this.reportFileList.push({ url: item })
              this.formExtend.forms.auditReportImgsList.push(item)
            })
            this.hideReportUpload = this.reportFileList.length >= 4
          }
        })
        .catch(error => {
          console.log(error)
        })
    },

    // 企业审核
    SaveCertificationReview(response) {
      SaveCertificationReview(response)
        .then(response => {
          this.submitCallback(response)
        })
        .catch(error => {
          console.log(error)
        })
    },
    // 审核完成时的回调函数
    submitCallback(response) {
      let type = response.code === 1 ? 'success' : 'error'
      let message = response.message
      this.$message({
        showClose: true,
        message: message,
        type: type,
        duration: 2000,
        onClose: () => {
          if (type === 'success') {
            this.$router.push({
              path: '/baseCertificationReviewList',
              query: { refreshportion: true }
            })
          }
          this.loadingState = false;
        }
      })
    },
    // 提交
    handleSubmitForm(e) {
      if(e) {
        if(this.formExtend.forms.examineMsg.toString().length<=100) {
      this.loadingState = true;
      this.SaveCertificationReview({
        comparyId: this.id,
        examineStatus: 2,
        examineMsg: this.formExtend.forms.examineMsg
      })
      }
      }
    },
    // 取消
    handleResetForm() {
      if(this.formExtend.forms.examineMsg) {
        if(this.formExtend.forms.examineMsg.toString().length<=100) {
        this.loadingState = true;
      this.SaveCertificationReview({
        comparyId: this.id,
        examineStatus: 3,
        examineMsg: this.formExtend.forms.examineMsg
      })
        }
      }else {
        this.$message({
          message: '请填写审核意见',
          type: 'warning'
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.remarkWidth{
  width: 70%;
}
.upload-demo {
  width: 300px;
  margin: 10 150px 10px 200px;
}
.page-view {
  height: 100%;
}
.title-section {
  padding: 15px 20px 10px;
}
.content-section {
  overflow: auto;
}
.content-section {
  .form-wrapper {
    padding-top: 20px;
    margin: 0 20px;
    background-color: #fff;
  }
}
.operate-section {
  margin: 0 10px;

  text-align: center;
  background: #fff;

  .el-button {
    padding: 10px 36px;
    font-size: 14px;
  }
}

/deep/.hide .el-upload--picture-card {
  display: none;
}
/deep/ .e6-from--column-2 {
  .el-input {
    width: 300px;
  }
  .el-textarea {
    width: 500px
  }
}
</style>
